import s from './Button.scss';
import React from 'react';
import clsx from 'clsx';
import { ContentWithLoader } from '../ContentWithLoader/ContentWithLoader';
export const Button = _ref => {
  let className = _ref.className,
    onClick = _ref.onClick,
    secondary = _ref.secondary,
    icon = _ref.icon,
    iconButton = _ref.iconButton,
    block = _ref.block,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    rounded = _ref.rounded,
    style = _ref.style,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$skin = _ref.skin,
    skin = _ref$skin === void 0 ? 'standard' : _ref$skin,
    children = _ref.children,
    dataHook = _ref.dataHook,
    noBounce = _ref.noBounce,
    suffixIcon = _ref.suffixIcon;
  const isPrimary = !secondary;
  const hasLetterSpacingBounceEffect = isPrimary && typeof children === 'string';
  const getContent = () => {
    if (!hasLetterSpacingBounceEffect || noBounce) {
      return children;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: s.bouncyTextContainer
    }, /*#__PURE__*/React.createElement(ContentWithLoader, {
      isLoading: !!isLoading
    }, /*#__PURE__*/React.createElement("span", {
      className: s.bouncyText
    }, children), /*#__PURE__*/React.createElement("span", {
      className: s.bouncyTextSpacer
    }, children)));
  };
  return /*#__PURE__*/React.createElement("button", {
    disabled: disabled,
    className: clsx(s.button, className, {
      [s.secondary]: secondary,
      [s.primary]: isPrimary,
      [s.large]: size === 'large',
      [s.medium]: size === 'medium',
      [s.small]: size === 'small',
      [s.tiny]: size === 'tiny',
      [s.block]: block,
      [s.loading]: isLoading,
      [s.rounded]: rounded,
      [s.premium]: skin === 'premium',
      [s.ai]: skin === 'ai',
      [s.iconButton]: iconButton
    }),
    style: style,
    onClick: onClick,
    "data-hook": dataHook
  }, icon && /*#__PURE__*/React.cloneElement(icon, {
    className: clsx(icon.props.className, s.prefixIcon)
  }) || null, getContent(), suffixIcon && /*#__PURE__*/React.cloneElement(suffixIcon, {
    className: clsx(suffixIcon.props.className, s.suffixIcon)
  }) || null);
};
//# sourceMappingURL=Button.js.map